module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/c7942c007d78f82c6fc954305fb97df4.png";